import React, { useState } from 'react';

const Projects = () => {
    const [selectedImage, setSelectedImage] = useState(null);

    return (
        <section className="ftco-section ftco-project" id="projects-section">
            <div className="container">
                <div className="row justify-content-center pb-5">
                    <div className="col-md-12 heading-section text-center" data-aos="fade-up">
                        <h1 className="big big-2">Projects</h1>
                        <h2 className="mb-4">Our Projects</h2>
                        <p>
                            Showcasing real-world projects spanning SaaS platforms, e-commerce systems, real-time applications, and cloud-integrated solutions built with robust backend architecture.
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <div className="project img ftco-animate d-flex justify-content-center align-items-center" style={{ backgroundImage: 'url(/images/project-1.png)', cursor: 'pointer' }} data-aos="fade-up" onClick={() => setSelectedImage('/images/project-1.png')}>
                            <div className="overlay"></div>
                            <div className="text text-center p-4">
                                <h3><a href="#" onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>Bamigbe | Car Rental & Delivery Platform</a></h3>
                                <span>Built Node.js + PostgreSQL APIs and React admin panel. Added real-time tracking with Socket.io.</span>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-8">
                        <div className="project img ftco-animate d-flex justify-content-center align-items-center" style={{ backgroundImage: 'url(/images/project-2.png)', cursor: 'pointer' }} data-aos="fade-up" onClick={() => setSelectedImage('/images/project-2.png')}>
                            <div className="overlay"></div>
                            <div className="text text-center p-4">
                                <h3><a href="#" onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>Chowtrux | Food Truck Platform</a></h3>
                                <span>Developed Laravel + MySQL APIs. Managed roles, trucks, and locations; integrated Authorize.net.</span>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-8">
                        <div className="project img ftco-animate d-flex justify-content-center align-items-center" style={{ backgroundImage: 'url(/images/project-3.png)', cursor: 'pointer' }} data-aos="fade-up" onClick={() => setSelectedImage('/images/project-3.png')}>
                            <div className="overlay"></div>
                            <div className="text text-center p-4">
                                <h3><a href="#" onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>250 POS | E-commerce Platform</a></h3>
                                <span>Created Laravel APIs, admin & vendor panels. Multi-store shopping with Mobile money+card payments.</span>
                            </div>
                        </div>

                        <div className="project img ftco-animate d-flex justify-content-center align-items-center" style={{ backgroundImage: 'url(/images/project-4.png)', cursor: 'pointer' }} data-aos="fade-up" onClick={() => setSelectedImage('/images/project-4.png')}>
                            <div className="overlay"></div>
                            <div className="text text-center p-4">
                                <h3><a href="#" onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>AOR</a></h3>
                                <span>
                                    Developed an employee communication app for AucklandOneRail with real-time updates, announcements, schedules, and operational information.
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="project img ftco-animate d-flex justify-content-center align-items-center" style={{ backgroundImage: 'url(/images/project-5.png)', cursor: 'pointer' }} data-aos="fade-up" onClick={() => setSelectedImage('/images/project-5.png')}>
                                    <div className="overlay"></div>
                                    <div className="text text-center p-4">
                                        <h3><a href="#" onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>WinWin</a></h3>
                                        <span>
                                            Built Node.js and MySQL APIs and a React admin panel. Added multi-language support and Stripe payments.
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="project img ftco-animate d-flex justify-content-center align-items-center" style={{ backgroundImage: 'url(/images/project-6.png)', cursor: 'pointer' }} data-aos="fade-up" onClick={() => setSelectedImage('/images/project-6.png')}>
                                    <div className="overlay"></div>
                                    <div className="text text-center p-4">
                                        <h3><a href="#" onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>Heimlu | Real Estate Platform</a></h3>
                                        <span>Built Node.js + PostgreSQL APIs and React admin panel. Added metro railway line and more filters with Socket.io.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Image Popup Modal */}
            {selectedImage && (
                <div
                    className="image-popup-modal"
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100vw',
                        height: '100vh',
                        backgroundColor: 'rgba(0, 0, 0, 0.85)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 9999,
                        cursor: 'pointer'
                    }}
                    onClick={() => setSelectedImage(null)}
                >
                    <div style={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={(e) => e.stopPropagation()}>
                        <img
                            src={selectedImage}
                            alt="Project Full Size"
                            style={{
                                maxWidth: '90vw',
                                maxHeight: '90vh',
                                objectFit: 'contain',
                                borderRadius: '8px',
                                boxShadow: '0 4px 15px rgba(0, 0, 0, 0.5)'
                            }}
                        />
                        <button
                            onClick={() => setSelectedImage(null)}
                            title="Close"
                            style={{
                                position: 'absolute',
                                top: '-40px',
                                right: '0',
                                background: 'none',
                                border: 'none',
                                color: 'white',
                                fontSize: '40px',
                                fontWeight: 'bold',
                                cursor: 'pointer',
                                padding: 0,
                                lineHeight: '1',
                                textShadow: '0 2px 4px rgba(0,0,0,0.5)'
                            }}
                        >
                            &times;
                        </button>
                    </div>
                </div>
            )}
        </section>
    );
};

export default Projects;
